import moment from 'moment'

import { IEnrollment } from 'main/gql/enrollment'
import { IEnrollmentApplication } from 'main/gql/enrollmentApplication'
import { HydratedLeadFields_tourRequests as ITourRequest } from 'main/gql/lead/__generated__/HydratedLeadFields'
import { ITour } from 'main/gql/tour'
import { DATE_FORMAT } from 'main/util/date'

export function filterActiveEnrollments(enrollments: IEnrollment[]) {
  return enrollments.filter(enrollment => enrollment.status === 'ENROLLED')
}

export function findPendingEnrollment(enrollments: IEnrollment[]) {
  return enrollments.find(enrollment => enrollment.status === 'PENDING')
}

export function findLatestUnenrolledEnrollment(enrollments: IEnrollment[]) {
  return enrollments
    .concat()
    .filter(enrollment => enrollment.status === 'UNENROLLED')
    .filter(enrollment => enrollment.endsOn)
    .sort((a, b) => dateComparator(a.endsOn as string, b.endsOn as string))[0]
}

export function findLatestEnrollmentApplication(enrollmentApplications: IEnrollmentApplication[]) {
  return enrollmentApplications
    .concat()
    .sort((a, b) => dateTimeComparator(a.insertedAt, b.insertedAt))[0]
}

export function findLatestTour(tours: ITour[]) {
  return tours.concat().sort((a, b) => dateTimeComparator(a.beginsAt, b.beginsAt))[0]
}

export function findLatestTourRequest(tourRequests: ITourRequest[]) {
  return tourRequests.filter(tr => !tr.acceptedAt && !tr.cancelledAt && !tr.deletedAt)[0]
}

function dateComparator(a: string, b: string) {
  return moment(a, DATE_FORMAT).isBefore(moment(b, DATE_FORMAT)) ? 1 : -1
}

function dateTimeComparator(a: string, b: string) {
  return moment(a).isBefore(moment(b)) ? 1 : -1
}
